export const inviteUser = (user) => (dispatch, getState, { api }) => {
  return api.post('/private/user/create', user);
}